import { render, staticRenderFns } from "./rateAvgMinPrice.vue?vue&type=template&id=327fdc86"
import script from "./rateAvgMinPrice.vue?vue&type=script&lang=js"
export * from "./rateAvgMinPrice.vue?vue&type=script&lang=js"
import style0 from "./rateAvgMinPrice.vue?vue&type=style&index=0&id=327fdc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports